import { Component, OnInit,Input } from '@angular/core';
import { ActivatedRoute, Router } from'@angular/router'
import { SingleMenu } from 'src/app/interfaces/singlemenu.interface'
import { Observable } from 'rxjs';
import { AngularFirestore, AngularFirestoreDocument, AngularFirestoreCollection } from '@angular/fire/firestore';
import { NgForm } from '@angular/forms';
import { Menureview } from 'src/app/interfaces/menureview';
import { ReviewService } from 'src/app/services/review.service';
import { AuthService } from 'src/app/services/auth.service';
import { CheckoutService } from 'src/app/services/checkout.service';
import { CartService } from 'src/app/services/cart.service';
import { TranslateService } from '@ngx-translate/core';
import { DishPhotos } from 'src/app/interfaces/dish-photos';
declare var $: any;

@Component({
  selector: 'app-singleprod',
  templateUrl: './singleprod.component.html',
  styleUrls: ['./singleprod.component.scss']
})
export class SingleprodComponent implements OnInit {

  @Input() singlemenu: SingleMenu;
  
  photoUrl:string = ''

  titleDisplay:string = ''

  title_arDisplay:string = ''

  descriptionDisplay:string = ''

  description_arDisplay:string = ''

  price:number = null

  id1:string;

  id2:string;

  linkRef: AngularFirestoreDocument<any>;

  linkRef2: AngularFirestoreCollection<any>;

  link: Observable<any>;
  
  rating:number = null;
  
  review: Menureview[] = []

  one = 1;

  two = 2;

  three = 3;

  four = 4;

  five = 5;

  length:number = null;

  userEmail: string = ''

  singlemenu2: SingleMenu[] = []

  dishPhoto: DishPhotos[] = []

  constructor(private route: ActivatedRoute,
              private fs: AngularFirestore,
              private newReview: ReviewService,
              private auth: AuthService,
              private checkout:CheckoutService,
              private router: Router,
              private order:CartService,
              private translate:TranslateService) { }

  title_ar:boolean = true
  title_en:boolean = false
  description_ar:boolean = true
  description_en:boolean = false

  ngOnInit(): void {

    this.route.paramMap.subscribe(params => this.id1 = params.get('id1'))

    this.route.paramMap.subscribe(params => this.id2 = params.get('id2'))
     
    this.linkRef = this.fs.doc(`menus/${this.id1}/singlemenu/${this.id2}`)
    
    this.link = this.linkRef.valueChanges();
 
    this.link.subscribe(data=> {
      this.singlemenu = data
      this.titleDisplay = data.title
      this.title_arDisplay = data.title_ar
      this.descriptionDisplay = data.description
      this.description_arDisplay = data.description_ar
      this.photoUrl = data.photoUrl
      this.price = data.price
    })

    this.linkRef2 = this.fs.collection(`menus/${this.id1}/singlemenu/${this.id2}/photos`)
    
    this.link = this.linkRef2.valueChanges();
 
    this.link.subscribe(data=> this.dishPhoto = data)

    this.newReview.id1 = this.id1;

    this.newReview.id2 = this.id2;

    this.newReview.getReview().subscribe(data=>{
      this.length = data.length
      this.review = data
    })
    if(this.length !=0) {
      document.getElementById('null-comments').style.display='none';
      document.getElementById('be-first').style.display='none';
    }
    this.userEmail = this.auth.userEmail;
    
    this.auth.user.subscribe(user=>{
      if(user){
        document.getElementById('reviews').style.display='block';
        document.getElementById('add-review').style.display='block';
      }
    })

    this.translate.onLangChange.subscribe( ()=> {
      if(this.translate.currentLang == "en") {
        this.description_ar = false
        this.description_en = true
        this.title_ar = false
        this.title_en = true
        document.getElementById("wont_published").classList.remove("right")
        document.getElementById("rating").classList.remove("float-right")
        document.getElementById("null-comments").classList.remove("right")
      }
      else if(this.translate.currentLang == "ar") {
        this.description_ar = true
        this.description_en = false
        this.title_ar = true
        this.title_en = false
        document.getElementById("wont_published").classList.add("right")
        document.getElementById("rating").classList.add("float-right")
        document.getElementById("null-comments").classList.add("right")
      }
    })

  }
  
  onItemChange(value:number){
    this.rating = +value;
 }
submit:boolean = true
  addReview(f:NgForm){
    this.submit = false
    let name = (<Menureview>f.value).name,
        message = (<Menureview>f.value).message;
        this.newReview.addReview(name,message,this.rating,this.userEmail)
        .then( ()=> {
          document.getElementById('done').style.display="block";
          setTimeout(()=>{
            document.getElementById('done').style.display="none";
            this.submit = true
        },4000)
      })              
  }
  
  add:boolean= false

  addtocart(){
    
    if(this.checkout.orderSubInfoLength !=0 ){
     
      this.router.navigate(['/checkout-guard'])
    
    }
    this.auth.user.subscribe(user=> {

      if(user)  this.add = true

      else this.router.navigate(['/login'])

    })
  }

  buy(amount:number){
    let selectedDish = this.singlemenu
    let data = {
      title: selectedDish.title,
      title_ar: selectedDish.title_ar,
      amount: +amount,
      price: +selectedDish.price,
      photo: selectedDish.photoUrl
    }
    // console.log(data)
     this.order.addToOrder(data)
     .then(()=> {
      this.add = false
       document.getElementById('done').style.display="block";
       setTimeout(()=>{
         document.getElementById('done').style.display="none";
       }, 5000);
     })
  }
}
